import React, { useEffect, memo } from 'react';
import { createUseStyles } from 'react-jss';

import MediaPlayer from 'app/lib/MediaPlayer';
import { useDispatcher, useSelector } from 'app/store/utils/redux/hooks';
import { IPageEnd } from 'app/store/nodes/card/interfaces';
import { useFlipbookContext } from 'app/components/common/flipbook/lib/hooks';

import Reply from './reply/Reply';
import Birthday from './birthday/Birthday';
import PromoPage from './page-promo/PagePromo';
import Holiday from './holiday/Holiday';
import PromoTSO from './promoTSO/PromoTSO';
import Download from './download/Download';

interface ILastPage {
  data?: IPageEnd,
}

const PageEnd: React.FC<ILastPage> = memo((props) => {
  const { data } = props;
  const classes = useStyles();

  const step = useSelector((state) => state.lastPage.currentStep);

  const { isOpened } = useFlipbookContext();
  const actions = useDispatcher();

  useEffect(() => {
    if (isOpened) {
      MediaPlayer.pauseAll('pageEnd');
    }
    return () => {
      if (isOpened) {
        MediaPlayer.resumeAll('pageEnd');
      }
    };
  }, [isOpened]);

  useEffect(() => {
    actions.hint.hide();
  }, [actions.hint]);

  if (!data?.items) {
    return <div />;
  }

  const stepType = data.itemsOrder[step] as 'promo' | 'reply' | 'birthday' | 'download' | 'holiday' | 'promoTSO';

  return (
    <div className={classes.componentPageEnd}>
      {stepType === 'reply' && <Reply data={data} />}
      {stepType === 'birthday' && <Birthday data={data} />}
      {stepType === 'holiday' && <Holiday data={data} />}
      {stepType === 'promo' && <PromoPage data={data} />}
      {stepType === 'promoTSO' && <PromoTSO data={data} />}
      {stepType === 'download' && <Download data={data} isHoliday />}
      {!['reply', 'promo'].includes(stepType) && (
        <div className={classes.information}>
          <a
            href="https://www.cardsnacks.com/terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms &amp; Conditions
          </a>
          <a
            href="https://www.cardsnacks.com/privacypolicy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </a>
        </div>
      )}
    </div>
  );
});

const useStyles = createUseStyles({
  componentPageEnd: {
    '&': {
      width: '100%',
      height: '100%',
      position: 'absolute',
      inset: '0 auto auto 0',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#26bda5!important',
    },
    '& a, & button': {
      pointerEvents: 'all',
    },
  },
  information: {
    '&': {
      position: 'relative',
      padding: '2rem 2rem 3.7rem 2rem',
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'flex-end',
      flex: 1,
    },
    '& a': {
      fontSize: '1.3rem',
      color: '#fff',
    },
  },
});

export default memo(PageEnd);
